// extracted by mini-css-extract-plugin
export default {"h1":"Title_h1__ICtdv","h2":"Title_h2__jhuba","h3":"Title_h3__Nh0ha","h4":"Title_h4__yAVPu","h5":"Title_h5__fjgZC"};